/* import __COLOCATED_TEMPLATE__ from './project-version.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();